import { useEffect } from "react";
import { PushNotifications } from "@capacitor/push-notifications";
import { Preferences } from "@capacitor/preferences";
import { registerPlugin } from "@capacitor/core";
import API from "../api";

const CallPlugin = registerPlugin("CallPlugin");

const usePush = () => {
  useEffect(() => {
    const openCallPage = (fromUserId, fromFirstname = "", fromLastname = "") => {
      localStorage.setItem(
        "pendingIncomingCall",
        JSON.stringify({
          mode: "incoming",
          member: {
            id: fromUserId,
            firstname: fromFirstname,
            lastname: fromLastname,
          },
        })
      );

      window.location.href = `/call/${fromUserId}`;
    };

    const initPush = async () => {
      console.log("🚀 INIT PUSH");

      try {
        await PushNotifications.createChannel({
          id: "calls",
          name: "Appels",
          description: "Notifications d'appel entrant",
          importance: 5,
          visibility: 1,
          sound: "default",
        });

        const { value: token } = await Preferences.get({ key: "token" });

        if (!token) {
          console.log("⛔ Pas connecté → push ignoré");
          return;
        }

        API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const perm = await PushNotifications.checkPermissions();

        if (perm.receive !== "granted") {
          const request = await PushNotifications.requestPermissions();

          if (request.receive !== "granted") {
            console.log("❌ permission refusée");
            return;
          }
        }

        await PushNotifications.removeAllListeners();

        PushNotifications.addListener("registration", async (tokenPush) => {
          console.log("🔥 PUSH TOKEN:", tokenPush.value);

          try {
            await API.post("/users/save-push-token", {
              pushToken: tokenPush.value,
            });

            console.log("✅ push token envoyé au backend");
          } catch (err) {
            console.error("❌ erreur save push", err);
          }
        });

        PushNotifications.addListener("registrationError", (err) => {
          console.error("❌ push error", err);
        });

        PushNotifications.addListener(
          "pushNotificationReceived",
          async (notification) => {
            console.log("📩 Notification reçue:", notification);

            const data =
              notification?.data || notification?.notification?.data || {};

            if (data.type === "incoming_call") {
              const fromUserId = data.fromUserId;
              const fromFirstname = data.fromFirstname || "";
              const fromLastname = data.fromLastname || "";

              if (!fromUserId) return;

              localStorage.setItem(
                "nativeIncomingCall",
                JSON.stringify({
                  fromUserId,
                  fromFirstname,
                  fromLastname,
                })
              );

              localStorage.setItem(
                "pendingIncomingCall",
                JSON.stringify({
                  mode: "incoming",
                  member: {
                    id: fromUserId,
                    firstname: fromFirstname,
                    lastname: fromLastname,
                  },
                })
              );

              try {
                await CallPlugin.showIncomingCall({
                  callerName:
                    `${fromFirstname} ${fromLastname}`.trim() ||
                    "Appel entrant",
                  conversationId: String(fromUserId),
                });

                console.log("✅ Appel natif affiché");
              } catch (err) {
                console.error("❌ CallPlugin showIncomingCall erreur:", err);
              }
            }
          }
        );

        PushNotifications.addListener(
          "pushNotificationActionPerformed",
          (notification) => {
            console.log("👉 Notification cliquée:", notification);

            const data = notification.notification?.data || {};

            if (data.type === "incoming_call") {
              openCallPage(
                data.fromUserId,
                data.fromFirstname || "",
                data.fromLastname || ""
              );
            }
          }
        );

        await PushNotifications.register();
      } catch (err) {
        console.error("❌ INIT PUSH ERROR", err);
      }
    };

    initPush();

    return () => {
      PushNotifications.removeAllListeners();
    };
  }, []);
};

export default usePush;